<template>
    <text-input
        type="tel"
        maxLength="20"
        :pattern="/[^0-9\-\(\) ]/g"
        :value="value" 
        @input="val => $emit('input', val)" />
</template>

<script>
export default {
    props: ['value'],
    components: {
        'text-input': require('components/form/BootstrapInput.vue'),
    },
}
</script>